import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=455f7670&scoped=true&"
import script from "./AppTabs.vue?vue&type=script&lang=js&"
export * from "./AppTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=455f7670&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f7670",
  null
  
)

export default component.exports